import { listItems } from '@/modules/inventory/services';
import { listMovementsForCompany } from '@/services/inventoryMovements/movementRepository';
import { isItemPhysicallyOut } from '@/services/inventoryMovements/itemTracking';
import { TRANSIT_LOCATION_SENTINEL } from '@/services/inventoryMovements/constants';

export type MovementDashboardStats = {
  itemsOut: number;
  itemsInTransit: number;
  recentTransfers: number;
  inventoryDiscrepancies: number;
  recentMovements: number;
};

export async function fetchMovementDashboardStats(): Promise<MovementDashboardStats> {
  const [items, movements] = await Promise.all([
    listItems(),
    listMovementsForCompany(),
  ]);

  const sevenDaysAgo = Date.now() - 7 * 24 * 60 * 60 * 1000;
  const recent = movements.filter((m) => m.createdAt.getTime() >= sevenDaysAgo);

  let itemsOut = 0;
  let itemsInTransit = 0;
  for (const item of items) {
    const itemMovs = movements.filter((m) => m.inventoryItemId === item.id);
    if (isItemPhysicallyOut(itemMovs)) itemsOut += 1;
    if (item.currentLocationId === TRANSIT_LOCATION_SENTINEL) {
      itemsInTransit += 1;
    }
  }

  return {
    itemsOut,
    itemsInTransit,
    recentTransfers: recent.filter((m) => m.type === 'transfer').length,
    inventoryDiscrepancies: movements.filter((m) =>
      m.notes.toLowerCase().includes('discrepancia'),
    ).length,
    recentMovements: recent.length,
  };
}
